// src/api/staff.api.ts
import { get, post, put, del, patch } from './client';
import { ApiResponse, StaffMember, CreateStaffDto, UpdateStaffDto } from '../types';

export const staffApi = {
  getStaff: () => {
    return get<ApiResponse<StaffMember[]>>('/staff');
  },

  createStaff: (data: CreateStaffDto) => {
    return post<ApiResponse<StaffMember>>('/staff', data);
  },

  updateStaff: (id: string, data: UpdateStaffDto) => {
    return put<ApiResponse<StaffMember>>(`/staff/${id}`, data);
  },

  toggleStaffActive: (id: string) => {
    return patch<ApiResponse<StaffMember>>(`/staff/${id}/toggle-active`);
  },

  deleteStaff: (id: string) => {
    return del<ApiResponse>(`/staff/${id}`);
  },
};
